const AboutSection = () => (
  <section id="about" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      {/* Section Label */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-0.5 bg-[#1a2b4a]" />
        <span className="text-[#1a2b4a] text-xs font-semibold tracking-[0.25em] uppercase">About Us</span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left Content */}
        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a2b4a] leading-tight mb-6">
            전립상회
          </h2>
          <p className="text-gray-500 text-base leading-relaxed mb-8">
            전립상회(PAC KOREA)는 전립선 건강을 위해 박문수 원장이 직접 설계한 프로엑티브 시리즈를 판매하고 있습니다. 전문 의료진의 임상 경험과 연구를 바탕으로 설계된 프로엑티브 시리즈는 최상의 원료를 엄선하고 소량 생산 방식으로 품질을 철저히 관리합니다. 고객 한 분 한 분의 건강을 최우선으로 생각하는 진심을 담아 만들었습니다.
          </p>

          {/* Award Badge */}
          <div className="inline-flex items-center gap-4 bg-gradient-to-r from-[#f9f3e3] to-[#fdf8ee] border border-[#d4a843]/30 rounded-xl px-5 py-4 mb-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#d4a843]/15 shrink-0">
              <i className="ri-award-fill text-[#c49a2a] text-xl" />
            </div>
            <div>
              <p className="text-[10px] font-semibold tracking-widest text-[#c49a2a] uppercase mb-0.5">2024 한국소비자산업평가</p>
              <p className="text-sm font-bold text-[#1a2b4a]">건강 분야 비타민제 부문 <span className="text-[#c49a2a]">우수상</span> 수상</p>
            </div>
          </div>

          {/* Certification Checklist */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { icon: 'ri-shield-check-line', label: 'HACCP 인증', desc: '식품 안전 관리 국제 기준' },
              { icon: 'ri-medal-line', label: 'GMP 인증', desc: '우수 건강기능식품 제조 기준' },
              { icon: 'ri-government-line', label: '식약처 인증', desc: '식품의약품안전처 공식 인증' },
              { icon: 'ri-award-line', label: 'ISO 인증', desc: '국제 품질 경영 시스템 인증' },
            ].map((cert, i) => (
              <div key={i} className="flex items-center gap-3 p-3.5 rounded-lg border border-gray-100 bg-gray-50/50">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1a2b4a]/8 shrink-0">
                  <i className={`${cert.icon} text-[#1a2b4a] text-sm`} />
                </div>
                <div>
                  <p className="text-xs font-bold text-[#1a2b4a]">{cert.label}</p>
                  <p className="text-[11px] text-gray-400 leading-tight">{cert.desc}</p>
                </div>
                <div className="ml-auto w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-emerald-500 text-sm font-bold" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Image */}
        <div className="relative">
          <div className="w-full h-[420px] md:h-[500px] rounded-xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/fe7a79f42e3b2627f9f66a6d30e0f3e4.jpeg"
              alt="프로엑티브 시리즈 제품"
              className="w-full h-full object-contain object-center bg-white"
            />
          </div>
          <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#1a2b4a]/8 rounded-xl -z-10" />
          <div className="absolute -top-4 -right-4 w-16 h-16 bg-[#1a2b4a]/5 rounded-full -z-10" />
        </div>
      </div>

      {/* Values */}
      <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-8">
        {[
          { icon: 'ri-heart-pulse-line', title: '건강 중심', desc: '전립선 건강을 위해 박문수 원장이 직접 설계한 제품으로, 고객의 건강을 최우선으로 생각합니다.' },
          { icon: 'ri-leaf-line', title: '최상의 원료', desc: '엄격한 기준으로 엄선한 최상급 원료만을 사용하여 효능과 안전성을 모두 보장합니다.' },
          { icon: 'ri-flask-line', title: '소량 생산', desc: '대량 생산 대신 소량 정밀 생산 방식으로 제품 하나하나의 품질을 철저히 관리합니다.' },
        ].map((v, i) => (
          <div key={i} className="flex flex-col items-start gap-4 p-6 rounded-xl bg-gray-50/60 border border-gray-100">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1a2b4a]/8">
              <i className={`${v.icon} text-[#1a2b4a] text-xl`} />
            </div>
            <div>
              <h3 className="text-base font-bold text-[#1a2b4a] mb-2">{v.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{v.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ── 박문수 원장 프로필 ── */}
      <div className="mt-24">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-0.5 bg-[#1a2b4a]" />
          <span className="text-[#1a2b4a] text-xs font-semibold tracking-[0.25em] uppercase">Expert Profile</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          {/* Profile Card */}
          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden border border-gray-100 bg-gradient-to-b from-[#f8f9fc] to-white">
              <div className="px-5 pt-6 pb-3 flex flex-col items-center">
                <p className="text-[#1a2b4a] text-2xl font-bold tracking-tight">박문수 원장</p>
                <p className="text-[#c49a2a] text-sm font-semibold tracking-widest uppercase mt-1">비뇨의학과 전문의</p>
              </div>

              <div className="p-5">
                {/* Quote */}
                <div className="flex gap-3 p-4 rounded-lg bg-[#f9f3e3] border border-[#d4a843]/20">
                  <i className="ri-double-quotes-l text-[#c49a2a] text-2xl shrink-0 leading-none mt-0.5" />
                  <p className="text-xs text-[#7a6030] leading-relaxed italic">
                    "서울대 비뇨기과 전문의로서 수십 년간 전립선 질환을 연구하고 치료해온 경험을 바탕으로, 예방과 관리에 최적화된 제품을 직접 설계했습니다."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Career & Credentials */}
          <div className="lg:col-span-3 space-y-8">
            {/* 학력 */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#1a2b4a]">
                  <i className="ri-graduation-cap-line text-white text-sm" />
                </div>
                <h3 className="text-base font-bold text-[#1a2b4a]">학력</h3>
              </div>
              <ul className="space-y-2 pl-2">
                {[
                  '서울대학교 의과대학',
                  '서울대학교 의과대학원 비뇨기과학 석사',
                  '서울대학교 의과대학원 비뇨기과학 박사',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-blank-circle-fill text-[#c49a2a] text-[6px] shrink-0 mt-2" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* 경력 */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#1a2b4a]">
                  <i className="ri-briefcase-line text-white text-sm" />
                </div>
                <h3 className="text-base font-bold text-[#1a2b4a]">경력</h3>
              </div>
              <ul className="space-y-2 pl-2">
                {[
                  '서울대학교병원 수련의',
                  '서울대학교병원 비뇨기과 전공의',
                  '공군항공의학적성훈련원 비뇨기과장',
                  '미 버지니아대학 비뇨기과 연수',
                  '서울대학병원운영 보라매병원 비뇨기과 전담의',
                  '서울대학교 의과대학 비뇨기과 전임강사',
                  '서울대학교 의과대학 비뇨기과 조교수',
                  '선릉탑비뇨기과 전립선클리닉 원장',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-blank-circle-fill text-[#c49a2a] text-[6px] shrink-0 mt-2" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* 학술활동 & 저서 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#1a2b4a]">
                    <i className="ri-file-list-3-line text-white text-sm" />
                  </div>
                  <h3 className="text-base font-bold text-[#1a2b4a]">학술활동</h3>
                </div>
                <ul className="space-y-2 pl-2">
                  {[
                    '대한비뇨기과학회 정회원',
                    '미국비뇨기과학회 준회원',
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-gray-500">
                      <i className="ri-check-double-line text-emerald-500 text-sm shrink-0 mt-0.5" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#1a2b4a]">
                    <i className="ri-book-2-line text-white text-sm" />
                  </div>
                  <h3 className="text-base font-bold text-[#1a2b4a]">저서</h3>
                </div>
                <ul className="space-y-2 pl-2">
                  {[
                    '전립선암 (공저)',
                    '전립선 QA (공저)',
                    '종양학 (공저)',
                    'PROSTATE UPDATE 10 YEARS (공저)',
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-gray-500">
                      <i className="ri-check-double-line text-emerald-500 text-sm shrink-0 mt-0.5" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* 국외 연구 논문 */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#1a2b4a]">
                  <i className="ri-article-line text-white text-sm" />
                </div>
                <h3 className="text-base font-bold text-[#1a2b4a]">연구실적 · 국외 학술지</h3>
              </div>
              <div className="space-y-2.5 pl-2">
                {[
                  { title: 'The application of an antiangiogenic gene (thrombospondin-1) in the treatment of human prostate cancer xenografts', journal: 'Cancer Gene Therapy · 2000' },
                  { title: 'Ethnic differences in the age-related distribution of serum prostate-specific antigen values: a study in a healthy Korean male population', journal: 'Urology · 2000' },
                  { title: 'Development of a new plasmid vector with PSA-promoter and enhancer expressing tissue-specificity in prostate carcinoma cell lines', journal: 'Anticancer Res · 2000' },
                  { title: 'Prognostic factors for survival in patients with transitional cell carcinoma of the bladder', journal: 'European Urology · 1996' },
                  { title: 'In situ extracorporeal shock wave lithotripsy for ureteral calculi', journal: 'Journal of Endourology · 1996' },
                  { title: 'A high-risk group for prostatism: a population-based epidemiological study in Korea', journal: 'British Journal of Urology · 1997' },
                  { title: 'Long-term effect of prostatic infarction in the rat', journal: 'British J Urology · 1998' },
                  { title: 'Prophylactic treatment of superficial bladder tumor', journal: 'International Journal of Urology · 1998' },
                  { title: 'Penile sensitivity in men with premature ejaculation', journal: 'Int J Impot Res · 1998' },
                ].map((paper, i) => (
                  <div key={i} className="flex gap-3 p-3 rounded-lg border border-gray-100 bg-gray-50/50">
                    <i className="ri-file-paper-2-line text-[#c49a2a] text-base shrink-0 mt-0.5" />
                    <div>
                      <p className="text-xs font-semibold text-[#1a2b4a] leading-snug">{paper.title}</p>
                      <p className="text-[11px] text-gray-400 mt-1">{paper.journal}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
